import {
  HStack,
  IconButton,
  ChevronLeftIcon,
  ChevronRightIcon,
  Box,
  Text,
} from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { MINUTE_STRIP_ID } from '../../plot/components/MinutePlot';
import { SINGLE_LEAD_STRIP_ID } from '../../plot/components/SingleLeadPlot';
import { stripByIdSelector } from '../../plot/selectors/strip.selectors';
import { leadNamesSelector } from '../selectors/signal.selectors';
import * as stripActions from '../../plot/actions/strip.actions';
import { clamp } from 'lodash';

const STRIP_IDS = [SINGLE_LEAD_STRIP_ID, MINUTE_STRIP_ID];

export const LeadSelector = () => {
  const dispatch = useDispatch();
  const leads = useSelector(leadNamesSelector);
  const singleStrip = useSelector(stripByIdSelector(SINGLE_LEAD_STRIP_ID));
  const selectedLead = singleStrip?.leads?.[0];
  const index = selectedLead ? leads.indexOf(selectedLead) : 0;

  const navigate = (step: number) => {
    if (!leads.length) return;
    const nextIndex = clamp(index + step, 0, leads.length - 1);
    if (nextIndex === index) return;

    STRIP_IDS.forEach((stripId) => {
      if (stripId) {
        dispatch(
          stripActions.update({
            stripId,
            strip: { leads: [leads[nextIndex]] },
          }),
        );
      }
    });
  };

  const isFirstLead = index <= 0;
  const isLastLead = index >= leads.length - 1;
  const dotsLabel = leads.map((lead) => (
    <Box key={lead} as='span'>
      <Text textStyle='label'>{lead === selectedLead ? lead : '○'}</Text>
    </Box>
  ));

  return (
    <HStack spacing='l' justifyContent='center' flexGrow={1}>
      <IconButton
        isDisabled={isFirstLead}
        variant='secondary'
        aria-label='previous'
        onClick={() => navigate(-1)}
        size='sm'
        icon={<ChevronLeftIcon fontSize='md' />}
        px='20px'
      />
      {dotsLabel}
      <IconButton
        isDisabled={isLastLead}
        variant='secondary'
        aria-label='next'
        onClick={() => navigate(1)}
        size='sm'
        icon={<ChevronRightIcon fontSize='md' />}
        px='20px'
      />
    </HStack>
  );
};
